import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { diff } from 'deep-object-diff';
import { siteBuilder } from '@/mixins/site-builder';
import mapItem from './map-item';

export default Vue.component('site-map', {
  template: require('./template.html'),
  components: {
    mapItem,
  },
  computed: {
    ...mapGetters(['currentSite', 'currentPage']),
  },
  mixins: [guid, siteBuilder],
  data() {
    return {
      showAll: false,
      initialState: null,
      initialPages: [],
      hasDuplicates: false,
      siteMapChanges: false,
    };
  },
  watch: {
    showModal(o) {
      if (o) {
        this.setInitialState();
        this.siteMapChanges = false;
        this.showAll = false;
        this.$nextTick(this.checkErrors);
      }
    },
  },
  props: ['show-modal', 'toggle-modal', 'set-loading'],
  methods: {
    setInitialState() {
      this.initialState = _.cloneDeep(this.currentSite.siteMap);
      this.initialPages = _.cloneDeep(this.currentSite.pages);
    },
    async saveSiteMap() {
      if (!this.hasDuplicates) {
        const initial = { map: this.initialState };
        const newMap = { map: this.currentSite.siteMap };
        const changes = diff(initial, newMap);
        // if there are changes to the site map
        if (changes.map) {
          this.$emit('set-loading', true);
          const notif = {
            id: this.guid(),
            type: 'success',
            message: 'Site map saved successfully!',
          };
          try {
            // save all data to db
            await this._SEND([{
              name: 'updateSiteMap',
              payload: {
                currentSite: this.currentSite,
              },
            }]);
            this.$log.debug('Successfully updated sitemap');
            // We then need to rebuild the structure of the site and push it to S3
            await this.callBuilder({
              publish: 'site',
              site: {
                _id: this.currentSite._id,
              },
            });
          } catch (e) {
            this.$log.error('error: ', e);
            notif.type = 'error';
            notif.message = `${e.message || e}. This has been reported.`;
            await this._reportError({
              error: e,
              fn: 'saveSiteMap',
            });
          } finally {
            this.$emit('set-loading', false);
            this.closeModal();
            // give some time for the modal to close
            setTimeout(() => {
              this.$store.dispatch('addNotification', notif);
            }, 500);
            this._trackEvent({
              type: 'update_sitemap',
              meta: {
                site_type: this.currentSite.type,
                site_tier: this.currentSite.tier,
                site_name: this.currentSite.alias,
                sitemap: this.currentSite.siteMap,
              },
            });
          }
        }
      }
    },
    async cancelSiteMap() {
      await this.$store.dispatch('setSiteMap', this.initialState);
      // we need to go and revert the page urls that were updated
      this.$store.dispatch('updatePageLinks', {
        sitemap: this.currentSite.siteMap,
      });
      this.closeModal();
    },
    closeModal() {
      this.$emit('toggle-modal');
    },
    checkErrors() {
      // this is used to show / hide the hint when there are duplicate pages in the same level with
      // the same URL. Need to use a different approach to check errors (see warnDouble notes).
      const $map = $(this.$refs.siteMap);
      setTimeout(() => {
        const $errors = $map.find('.editorUi-duplicatePage-folder');
        if ($errors.length) {
          this.hasDuplicates = true;
        } else {
          this.hasDuplicates = false;
        }
      }, 250);
    },
    async rearrangePages(data) {
      this.siteMapChanges = true;
      await this.$store.dispatch('rearrangeSiteMap', data);
      this.$store.dispatch('setSiteMap');
      this.checkErrors();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/site-map/index.js